import { useLang } from "@/context/LanguageContext";

export default function Disclaimer() {
  const { t } = useLang();
  return (
    <div className="max-w-4xl mx-auto px-5 lg:px-8 py-20" data-testid="disclaimer-page">
      <h1 className="text-4xl sm:text-5xl font-bold">{t.disclaimer.title}</h1>
      <div className="mt-8 card-mift p-8 text-slate-300 leading-relaxed">
        {t.disclaimer.body}
      </div>
    </div>
  );
}
